import { Field, formValueSelector, reduxForm } from 'redux-form';
import {  
  isInteger,
  isValidNameWithSpace,
  renderCheckBox,  
  renderTextField,
} from '../../../components/reduxFields';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import React from 'react';
import { getPromptCodeDetail, savePromptCode } from './actions/PromptCodeActions';
import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../components/buttons';
import SmallLoader from '../../../img/small-loader.gif';
import { checkFieldExistence, clearFieldErrorArray } from '../../../modules/AppConfig/actions';
import { displayCustomError } from '../../../../src/actions/utilAction';
import { MODULE } from './constants/ApiConstants';

const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = 'Please enter prompt name';
  }
  if (!values.abbreviation) {
    errors.abbreviation = 'Please enter abbreviation';
  }
  // if (!values.defaultDuration) {
  //   errors.defaultDuration = 'Please enter default time duration';
  // }
  return errors;
};


/**
 * Dialog content can be scrollable.
 */
class PromptCodeModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
    };
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  componentWillMount() {
    if (this.props.promptCodeId) {
      this.props.getPromptCodeDetail(this.props.promptCodeId);
    }
  }

  handleOpen = () => {
    this.setState({ open: true });
  };
  handleClose = () => {
    if (this.state.open) {
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };
  componentWillReceiveProps(nextProps) {
    let self = this;
    document.onkeydown = function (evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }

  onSubmitHandler(formProps) {
    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }

    let postData = {
      "id": this.props.promptCodeId || 0,
      "name": formProps.name,
      "abbreviation": formProps.abbreviation,
      "scoreAsIndependent": formProps.scoreAsIndependent || false,
      "dtt": formProps.dtt || false,
      "ta": formProps.ta || false,
      "maintenance": formProps.maintenance || false,
      "peakScore": formProps.peakScore || 0,
      "isActive":  formProps.isActive || false
    }

    // console.log(postData);
    this.props.savePromptCode(postData);
    this.props.closeDialog();
  }

  checkFieldDataExistence = (input, value, labelName) => {
    if (value.length > 0) {
      let postData = {
        'labelName': labelName,
        'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
        'value': value,
        'colmnName': input.target.name.toUpperCase(),
        'id': this.props.promptCodeId || 0,
      };
      this.props.checkFieldExistence(postData);
    }
  };


  renderLoading() {
    return (
      <div>
        {this.props.loading ?
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
          : null}
      </div>
    );
  }

  render() {
    const { handleSubmit } = this.props;
    let submitButton = this.props.loading ?
      <SubmitButtonModalDisabled label="Loading" /> :
      <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />;
    const actions = [
      <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
      submitButton,
    ];
    return (
      <div>
        <Dialog
          className="custom_modal"
          title={this.props.promptCodeId ? 'Edit Prompt Code' : 'Add Prompt Code'}
          modal={false}
          open={this.state.open}
          actions={actions}
          autoScrollBodyContent={true}
        >
          {this.renderLoading()}
          <div className="row">
            <div className="col-sm-12">
              <form className="readmin-form custom_form">
                <div className="row">
                  <div className='col-sm-6 require'>
                    <Field
                      autoFocus={true}
                      name="name"
                      type="text"
                      onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Prompt Name')}
                      customError={displayCustomError('NAME', this.props.fieldError)}        
                      maxLength="250"
                      floatingLabelText="Prompt Name"
                      normalize={isValidNameWithSpace}
                      component={renderTextField}
                      fullWidth={true}
                    />
                  </div>
                  <div className='col-sm-3 require'>
                    <Field
                      name="abbreviation"
                      type="text"
                      floatingLabelText="Abbreviation"
                      component={renderTextField}
                      fullWidth={true}
                      maxLength="5"
                    />
                  </div>
                  <div className="col-sm-3">
                    <Field
                      name="peakScore"
                      type="text"
                      maxLength="2"
                      label="PEAK Score"
                      component={renderTextField}
                      normalize={isInteger}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <Field className="mt20 mb0 custm_check"
                      name="scoreAsIndependent"
                      label="Score As Independent"
                      component={renderCheckBox}
                      value={true}
                    />
                  </div>
                  <div className="col-sm-6">
                    <Field className="mt20 mb0 custm_check"
                      name="dtt"
                      label="DTT"
                      component={renderCheckBox}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <Field className="mt20 mb0 custm_check"
                      name="ta"
                      label="TA"
                      component={renderCheckBox}
                    />
                  </div>
                  <div className="col-sm-6">
                    <Field className="mt20 mb0 custm_check"
                      name="maintenance"
                      label="Maintenance"
                      component={renderCheckBox}
                    />
                  </div>
                </div>
                <div className="row">                  
                  <div className="col-sm-4">
                    <Field className="mt20 mb0 custm_check"
                      name="isActive"
                      label="Is Active"
                      component={renderCheckBox}
                    />
                  </div>
                  <div className="col-sm-8">
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

//const selector = formValueSelector('PromptCodeModalForm');
const mapStateToProps = (state, ownProps) => {
  let initialValueData = {
    isActive: true,
  };
  if (ownProps.promptCodeId && state.prompt_code.promptCodeDetail) {
    initialValueData = state.prompt_code.promptCodeDetail.data;
  }
  return {
    initialValues: initialValueData,
    fieldError: state.appConfig.fieldError,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
    promptCodeDetail: state.prompt_code.promptCodeDetail,
    loading: state.prompt_code.loading,
  };
};

PromptCodeModal = reduxForm({
  form: 'PromptCodeModalForm', // a unique identifier for this form
  validate,
  enableReinitialize: true,
})(PromptCodeModal);

export default connect(mapStateToProps, { savePromptCode, getPromptCodeDetail, checkFieldExistence, clearFieldErrorArray })(PromptCodeModal);



// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/promptCodes/propmt_codes_modal.js